/* eslint-disable no-redeclare */
import {
  DomainSessionId,
  DomainUserId,
  HealthcareSessionId,
  HealthcareUserId,
  SubProductType,
  Url,
  UUID,
} from '@hc-frontend/core-types';
import { z } from 'zod';

export const UpdateProspectLeadIdParameters = z.object({
  userId: HealthcareUserId,
  sessionId: HealthcareSessionId,
  domainUserId: DomainUserId.optional(),
  domainSessionId: DomainSessionId.optional(),
  leadId: UUID,
  subProductType: SubProductType.optional(),
  trustedFormUrl: Url,
});

export type UpdateProspectLeadIdParameters = z.infer<
  typeof UpdateProspectLeadIdParameters
>;
